const PALETTE = {
  PRIMARY: "#b58479",
  SECONDARY: "#707070",
};

export { PALETTE };
